import { differenceInCalendarDays } from 'date-fns';
import { formatDate, toDate } from '@/helpers/date';
import { Employee } from '@/model/employee';

export function hasLeft(employee: Employee): boolean {
  return (
    !!employee.last_day &&
    differenceInCalendarDays(new Date(), toDate(employee.last_day)) > 0
  );
}

export function isLeaving(employee: Employee): boolean {
  return !!employee.last_day && !hasLeft(employee);
}

export function canBeInvited(employee: Employee): boolean {
  return employee.user_id === null && !employee.last_day;
}

export function formattedLastDay(employee: Employee): string {
  return formatDate(employee.last_day);
}
